import { MyQrCode } from '@organisms/MyQrCode';
import { QrScanner } from '@organisms/QrScanner';
import { withAuthGate } from '@sunrise-ui/composites';
import {
  Colors,
  TextReg,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React, { useState } from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';

type QrMode = 'my-qr' | 'scan-qr';

function QrCodeScreen() {
  const styles = useDynamicStyles(createStyles);
  const [mode, setMode] = useState<QrMode>('my-qr');

  return (
    <View style={styles.container}>
      <View style={styles.toggleContainer}>
        <View style={styles.toggle}>
          <TouchableOpacity
            style={[
              styles.toggleButton,
              mode === 'my-qr' && styles.toggleButtonActive,
            ]}
            onPress={() => setMode('my-qr')}
            activeOpacity={0.7}
          >
            <TextReg
              style={[
                styles.toggleButtonText,
                mode === 'my-qr' && styles.toggleButtonTextActive,
              ]}
              numberOfLines={1}
            >
              My QR
            </TextReg>
          </TouchableOpacity>
          <TouchableOpacity
            style={[
              styles.toggleButton,
              mode === 'scan-qr' && styles.toggleButtonActive,
            ]}
            onPress={() => setMode('scan-qr')}
            activeOpacity={0.7}
          >
            <TextReg
              style={[
                styles.toggleButtonText,
                mode === 'scan-qr' && styles.toggleButtonTextActive,
              ]}
              numberOfLines={1}
            >
              Scan QR
            </TextReg>
          </TouchableOpacity>
        </View>
      </View>

      <View style={styles.content}>
        {mode === 'my-qr' ? <MyQrCode /> : <QrScanner />}
      </View>
    </View>
  );
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    toggleContainer: {
      paddingHorizontal: isMobile ? 16 : 24,
      paddingTop: isMobile ? 16 : 24,
      alignItems: 'center',
    },
    toggle: {
      flexDirection: 'row',
      backgroundColor: Colors.opacity05,
      borderRadius: isMobile ? 18 : 24,
      padding: 3,
      minWidth: isMobile ? 200 : 240,
    },
    toggleButton: {
      flex: 1,
      borderRadius: isMobile ? 15 : 21,
      height: isMobile ? 28 : 40,
      paddingHorizontal: isMobile ? 18 : 26,
      justifyContent: 'center',
      alignItems: 'center',
    },
    toggleButtonActive: {
      backgroundColor: Colors.opacity20,
    },
    toggleButtonText: {
      fontSize: isMobile ? 12 : 14,
      color: Colors.text,
      fontWeight: '500',
      textAlign: 'center',
    },
    toggleButtonTextActive: {
      fontWeight: '600',
    },
    content: {
      flex: 1,
    },
  });

export default withAuthGate(QrCodeScreen);
